<template>
  <div class="cenario-loading">
    <LoadingPadraoContainer
      :fraseLoading="['Criando Cenário', 'Aguarde um momento']"
      delay="5000"
      classe="azul"
    />
  </div>
</template>

<script>
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  name: "CenarioLoading",
  components: {
    LoadingPadraoContainer
  }
};
</script>

<style lang="scss" scoped>
.cenario-loading {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1000;
  color: var(--branco);
  font-size: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00000060;
}
</style>
